import { FlowName } from '@fiverr-private/listing_types';
import { GigBusinessCategoriesFlow, GigBusinessSearchFlow, GigCategoriesFlow, GigSearchFlow } from './GigFlows';

type FlowType =
    | typeof GigCategoriesFlow
    | typeof GigSearchFlow
    | typeof GigBusinessCategoriesFlow
    | typeof GigBusinessSearchFlow;

type FlowMapper = {
    [key in FlowName]: FlowType;
};

export const flowMapper: FlowMapper = {
    gigSearchFlow: GigSearchFlow,
    gigCategoriesFlow: GigCategoriesFlow,
    gigBusinessSearchFlow: GigBusinessSearchFlow,
    gigBusinessCategoriesFlow: GigBusinessCategoriesFlow,
};
